import dayjs from "dayjs";
import flatpickr from "flatpickr";
import "flatpickr/dist/themes/material_green.css";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";

const localeMap = {
  ru: () => import("flatpickr/dist/l10n/ru.js"),
  fr: () => import("flatpickr/dist/l10n/fr.js"),
  es: () => import("flatpickr/dist/l10n/es.js"),
  de: () => import("flatpickr/dist/l10n/de.js"),
  pt: () => import("flatpickr/dist/l10n/pt.js"),
  it: () => import("flatpickr/dist/l10n/it.js"),
  // fi:()=>import('/flatpickr/dist/l10n/fi.js'),
  sv: () => import("flatpickr/dist/l10n/sv.js"),
  el: () => import("flatpickr/dist/l10n/gr.js"),
  nb: () => import("flatpickr/dist/l10n/no.js"),
  pl: () => import("flatpickr/dist/l10n/pl.js"),
  iw: () => import("flatpickr/dist/l10n/he.js"),
  ar: () => import("flatpickr/dist/l10n/ar.js"),
  nl: () => import("flatpickr/dist/l10n/nl.js"),
  ja: () => import("flatpickr/dist/l10n/ja.js"),
  tr: () => import("flatpickr/dist/l10n/tr.js"),
  hu: () => import("flatpickr/dist/l10n/hu.js"),
  zh_CN: () => import("flatpickr/dist/l10n/zh.js"),
  zh_TW: () => import("flatpickr/dist/l10n/zh-tw.js"),
  ko: () => import("flatpickr/dist/l10n/ko.js"),
};
const localeMapper = (locale) => {
  switch (locale) {
    case "el":
      return "gr";
    case "nb":
      return "no";
    case "iw":
      return "he";
    case "zh_CN":
      return "zh";
    case "zh_TW":
      return "zh-tw";
    default:
      return locale;
  }
};

const isEqualArray = (a, b) => {
  return (
    a.every((item) => b.includes(item)) && b.every((item) => a.includes(item))
  );
};

const localeCache = {};
async function loadLocale(locale) {
  let lang = locale || "en";
  if (!localeMap[lang]) {
    return Promise.resolve();
  }
  if (localeCache[lang]) {
    return Promise.resolve(localeCache[lang]);
  }
  const l = await localeMap[locale]().then((d) => {
    return d.default[localeMapper(locale)];
  });
  localeCache[lang] = l;
  return l;
}
function RangePicker({
  onChange,
  startDate,
  config,
  placeholder,
  className,
  endDate,
}) {
  const locale = useSelector((state) => state.settings.locale || "en");
  const [loading, setLoading] = useState(true);
  const [localeData, setLocaleData] = useState();
  useEffect(() => {
    setLoading(true);
    loadLocale(locale).then((data) => {
      setLoading(false);
      setLocaleData(data);
    });
  }, [locale]);
  if (loading) {
    return <Skeleton height={36.5} />;
  } else {
    return (
      <RangePickerInternal
        onChange={onChange}
        lang={localeData}
        placeholder={placeholder}
        className={className}
        startDate={startDate}
        config={config}
        endDate={endDate}
      />
    );
  }
}

function RangePickerInternal({
  onChange,
  placeholder,
  lang,
  startDate,
  className,
  config,
  endDate,
}) {
  const locale = useSelector((state) => state.settings.locale || "en");
  const setMaxMin = (values) => {
    const start = dayjs(values[0]).startOf("day").format("YYYY-MM-DD");
    const end = dayjs(values[1] || values[0])
      .endOf("day")
      .format("YYYY-MM-DD");
    if (
      start !== dayjs(startDate).format("YYYY-MM-DD") ||
      end !== dayjs(endDate).format("YYYY-MM-DD")
    ) {
      onChange(values);
    }
  };
  const pickerRef = useRef();
  const [pickerInstance, setPickerInstance] = useState(null);
  useEffect(() => {
    let pickerInstance = null;
    if (pickerRef && pickerRef.current) {
      const props = {
        mode: "range",
        dateFormat: locale !== "ja" ? "j M Y" : "Y-m-d",
        onClose: setMaxMin,
        defaultDate: [startDate, endDate],
        //                maxDate: dayjs().endOf('day').toDate(),
        ...config,
      };
      if (lang) {
        props.locale = lang;
      } else {
        delete props.locale;
      }
      pickerInstance = flatpickr(pickerRef.current, props);
      setPickerInstance(pickerInstance);
    }
    return () => {
      if (pickerInstance && pickerInstance.destroy) {
        pickerInstance.destroy();
      }
    };
  }, [pickerRef.current, startDate, endDate, config]);

  // useEffect(() => {
  //     if(pickerInstance && pickerInstance.setDate && startDate && endDate){
  //        // pickerInstance.setDate([startDate, endDate], false)
  //     }
  // }, [startDate, pickerInstance, endDate])
  return (
    <input
      placeholder={placeholder}
      className={`form-control bg-white ${className || ""}`}
      ref={pickerRef}
    />
  );
}

RangePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  config: PropTypes.any,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
};

export default RangePicker;
